import React from 'react';
import classnames from 'classnames';
import { Button, Icon } from 'tea-component';

import type { IBaseProps } from '@intelligence/types/common';

import './index.scss';

type ISwiperType = 'prev' | 'next';

interface ISwiperBtnProps extends IBaseProps {
  type: ISwiperType;
  disabled: boolean;
  // 是否开启边缘渐变效果（滑动体边缘被遮挡部分，有个透明渐变效果，让用户更容易发现 有内容被遮挡，可以点击滑动按钮滑动 查看 遮挡的内容），默认关闭
  gradient?: boolean;
  onClick: (payload: ISwiperType) => void;
  iconType?: string;
}

const SwiperBtn: React.FC<ISwiperBtnProps> = (props) => {
  const { type = 'next', disabled = false, gradient = false, onClick, className, style, iconType } = props;

  const isLeftType = type === 'prev';
  const wrapperClassName = classnames('dba-swiper-icon-wrap', className, {
    'dba-swiper-icon-wrap--left': isLeftType,
    'dba-swiper-icon-wrap--right': !isLeftType,
    'dba-swiper-icon-wrap--gradient': gradient,
    'dba-swiper-icon-wrap--disabled': disabled,
  });

  const handleClick = () => {
    if (!disabled) {
      onClick(type);
    }
  };

  return (
    <Button
      style={style}
      className={wrapperClassName}
      type="link"
      disabled={disabled}
    >
      <div 
        className={classnames('dba-swiper-icon', { disabled })} 
        onClick={handleClick}
      >
        <Icon type={iconType} className="dbi-swiper-arrow" />
      </div>
    </Button>
  );
};

export default SwiperBtn;
